/* MistWyrm theme — small, dependency-free */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- mobile menu ---------- */
  function initMenu() {
    $$('[data-menu-toggle]').forEach(function (btn) {
      var nav = document.getElementById(btn.getAttribute('aria-controls'));
      if (!nav) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        nav.hidden = open;
      });
    });
  }

  /* ---------- product gallery ---------- */
  function initGallery(root) {
    var track = $('[data-gallery-track]', root);
    if (!track) return;
    var slides = $$('[data-gallery-slide]', root);
    var thumbs = $$('[data-gallery-thumb]', root);
    var dots = $$('[data-gallery-dot]', root);

    function setCurrent(i) {
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    function goTo(i) {
      var slide = slides[i];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setCurrent(i);
    }
    thumbs.concat(dots).forEach(function (el) {
      el.addEventListener('click', function () { goTo(parseInt(el.getAttribute('data-index'), 10)); });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        setCurrent(i);
        ticking = false;
      });
    }, { passive: true });

    root.addEventListener('gallery:goto-media', function (e) {
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(e.detail); });
      if (idx > -1) goTo(idx);
    });
  }

  /* ---------- quantity ---------- */
  function initQty(root) {
    $$('[data-qty]', root).forEach(function (wrap) {
      var input = $('input', wrap);
      $$('button', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-step'), 10);
          var min = parseInt(input.min || '0', 10);
          var v = Math.max(min, (parseInt(input.value, 10) || 0) + step);
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      if (wrap.hasAttribute('data-autosubmit')) {
        input.addEventListener('change', function () { if (input.form) input.form.submit(); });
      }
    });
  }

  /* ---------- variants ---------- */
  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var noDec = Math.round(cents / 100).toString();
    var withComma = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withComma);
  }

  function initVariants(root) {
    var dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var picker = $('[data-variant-picker]', root);
    var idInputs = $$('input[name="id"]', root);

    function current() {
      if (!picker) return null;
      var chosen = $$('fieldset', picker).map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      }) || null;
    }

    function update() {
      var v = current();
      var buttons = $$('[data-add-button]', root).concat($$('[data-sticky-atc] [data-add-button]'));
      if (!v) {
        buttons.forEach(function (b) { b.disabled = true; var l = $('[data-label]', b); if (l) l.textContent = 'Unavailable'; });
        return;
      }
      $$('fieldset', picker).forEach(function (fs) {
        var c = $('input:checked', fs), l = $('[data-option-value]', fs);
        if (c && l) l.textContent = c.value;
      });
      idInputs.forEach(function (i) { i.value = v.id; i.dispatchEvent(new Event('change', { bubbles: true })); });
      $$('[data-price-now]').forEach(function (el) { el.textContent = money(v.price, data.money_format); });
      $$('[data-price-was]').forEach(function (el) {
        var on = v.compare_at_price && v.compare_at_price > v.price;
        el.hidden = !on;
        if (on) el.textContent = money(v.compare_at_price, data.money_format);
      });
      $$('[data-price-badge]').forEach(function (el) {
        var on = v.compare_at_price && v.compare_at_price > v.price;
        el.hidden = !on;
        if (on) el.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
      });
      $$('[data-btn-price]').forEach(function (el) { el.textContent = money(v.price, data.money_format); });
      buttons.forEach(function (b) {
        b.disabled = !v.available;
        var l = $('[data-label]', b);
        if (l) l.textContent = v.available ? b.getAttribute('data-label-available') : 'Sold out';
      });
      if (v.featured_media) {
        var gallery = $('[data-gallery]', root);
        if (gallery) gallery.dispatchEvent(new CustomEvent('gallery:goto-media', { detail: v.featured_media.id }));
      }
      if (data.update_url && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (picker) picker.addEventListener('change', update);
  }

  /* ---------- sticky add to cart ---------- */
  function initSticky() {
    var bar = $('[data-sticky-atc]');
    var mainBtn = $('[data-main-add-button]');
    if (!bar || !mainBtn) return;
    var footer = $('.footer');
    var mainVisible = true, footerVisible = false;
    function render() { bar.classList.toggle('is-visible', !mainVisible && !footerVisible); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        mainVisible = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
        render();
      }).observe(mainBtn);
      if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; render(); }).observe(footer);
    }
    var stickyBtn = $('[data-add-button]', bar);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (mainBtn.disabled) return;
        // Clicking the real button keeps any bundle-app logic attached to the main form.
        mainBtn.click();
      });
    }
  }

  /* ---------- delivery dates ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }
  function initDelivery() {
    var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    $$('[data-delivery-date]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min') || '0', 10);
      var max = parseInt(el.getAttribute('data-max') || '0', 10);
      var now = new Date();
      if (max === 0) { el.textContent = fmt(now); return; }
      var a = addBusinessDays(now, min), b = addBusinessDays(now, max);
      el.textContent = min === max ? fmt(a) : fmt(a) + ' – ' + fmt(b);
    });
  }

  /* ---------- horizontal scrollers ---------- */
  function initScrollers() {
    $$('[data-scroller]').forEach(function (wrap) {
      var track = $('.scroller', wrap);
      if (!track) return;
      $$('[data-dir]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-dir'), 10);
          track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------- reveal ---------- */
  function initReveal() {
    var els = $$('.reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initProduct(root) {
    initGallery(root);
    initQty(root);
    initVariants(root);
  }

  function initUpsell() {
    $$('[data-upsell-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Adding…';
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(btn.getAttribute('data-upsell-add')), quantity: 1 })
        }).then(function () { window.location.reload(); })
          .catch(function () { window.location.href = btn.href; });
      });
    });
  }

  function init() {
    initMenu();
    $$('[data-product-section]').forEach(initProduct);
    initQty($('[data-cart]') || document.createElement('div'));
    initUpsell();
    initSticky();
    initDelivery();
    initScrollers();
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-init a section when it is reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    var p = $('[data-product-section]', e.target);
    if (p) initProduct(p);
    initDelivery();
    initScrollers();
    $$('.reveal', e.target).forEach(function (el) { el.classList.add('is-in'); });
  });
})();
